/**
 * IKey — константы для веб-клиента.
 */
export const IKey = {
  JS_WEB_RESPONSE: '__js_web_response',
  JS_WEB_EXCEPTION: '__js_web_exception',
  JS_PROGRESS_BAR_RESPONSE: '__js_progress_bar_response',
  JS_MESSAGES_RESPONSE: '__js_messages_response',
  /** LocalProperties.ELEMENT_STATE */
  ELEMENT_STATES: 'element_states',
  /** IKey._LABEL_DATA — динамический текст Label в UniData (`{name}__label_data`). */
  LABEL_DATA: '__label_data',
  // autocomplete
  METHOD: 'method()',
  GET_AUTO_COMPLETE_LIST: 'getAutoCompleteList',
  AUTO_COMPLETE_FILTER: 'filter',
  AUTO_COMPLETE_CURSOR: 'cursor',
  AUTO_COMPLETE_FORCED: 'forced',
  ALTERNATIVES_SUFFIX: '__alternatives',
  ROW_NUM: 'rowNum',
  COLUMN: 'column',
  /** IKey._PARAMS — параметры раскрытия узла TreeTable */
  PARAMS: '_params',
  /** IKeys.TT_COUNT_CHILDREN — число детей на сервере для узла дерева. */
  TT_COUNT_CHILDREN: '_countChildren',
  /** IKey.TT_IS_ALLOW_CHILDREN — у узла есть (или могут быть) дети. */
  TT_IS_ALLOW_CHILDREN: 'isAllowChildren',
  /** IKey.TT_HIDE_CHECKBOX — скрыть checkbox у строки. */
  TT_HIDE_CHECKBOX: 'hideCheckbox',
  /** IKey.TT_HIDE_CHECKBOX_LEVEL — CSV уровней без checkbox (XML). */
  TT_HIDE_CHECKBOX_LEVEL: 'hideCheckBoxLevel',
  /** IKey.TT_HIDE_CHECKBOX_ON_ALL_LEVEL — скрыть checkbox на всех уровнях. */
  TT_HIDE_CHECKBOX_ON_ALL_LEVEL: 'hideCheckBoxOnAllLevel',
  /** IKey.TT_CHECKING_MODE — режим checkbox TreeTable. */
  TT_CHECKING_MODE: 'checkingMode',
  /** IKey.TT_FORBID_SELECT_NODE — XML: выбирать только листья. */
  TT_FORBID_SELECT_NODE: 'forbidSelectNode',
  /** IKeys.TT_FORBID_TO_SELECT_NODE — поле строки: запрет выбора узла. */
  TT_FORBID_TO_SELECT_NODE: 'forbidToSelectNode',
  /** IKeys.TT_IS_DROP_TARGET — можно ли бросать на этот узел. */
  TT_IS_DROP_TARGET: '_isDropTarget',
  /** IKeys.TT_VISIBLE_ROOT_NODE — показать кастомный корень (дерево вверх). */
  TT_VISIBLE_ROOT_NODE: 'showRootNode',
  /** IKeys.TT_ACTION_FIND_PARENT_ROOT_ASINC — reload: найти родителя корня. */
  TT_ACTION_FIND_PARENT_ROOT_ASINC: 'findParentRootAsinc',
  /** IKeys.TT_DESC_ROOT — заголовок кастомного корня. */
  TT_DESC_ROOT: 'descRoot',
  /** IKeys.TT_MES_CANNOT_OPEN_PARENT — нельзя получить родителя. */
  TT_MES_CANNOT_OPEN_PARENT: 'mesCannotOpenParent',
  /** IKeys.TT_MES_PARENT_NOT_FOUND — родительских узлов больше нет. */
  TT_MES_PARENT_NOT_FOUND: 'mesParentNotFound',
  /** IKeys.TT_FORMSTATE_OPTIONS — сохранять развёрнутость дерева. */
  TT_FORMSTATE_OPTIONS: 'showFormStateOptions',
  /** IKeys.TABLE_STYLE — предустановленный стиль таблицы. */
  TABLE_STYLE: 'table_style',
  /** IKey.HIDE_BORDER — скрыть рамку. */
  HIDE_BORDER: 'hideBorder',
  /** IKey.SHOW_CONTROL_PANEL — панель пагинации. */
  SHOW_CONTROL_PANEL: 'showControlPanel',
  /** IKey.EXPAND_BY_DEFAULT — раскрыть узлы по умолчанию. */
  EXPAND_BY_DEFAULT: 'expandByDefault',
  /** IKeys.MAX_ON_PAGE_VALUES — значения page-size через `;`. */
  MAX_ON_PAGE_VALUES: 'maxOnPageValues',
  /** IKey._PAGE — `{name}__page`. */
  PAGE: '__page',
  /** IKey._MAX_ON_PAGE — `{name}__maxOnPage`. */
  MAX_ON_PAGE: '__maxOnPage',
  /** IKeys.TT_INIT — полная переинициализация дерева (reloadNode rowNum === -1). */
  TT_INIT: '__initTreeTable',
  /** IKeys.TT_FORCE_LOAD_ALL — принудительно загрузить всё дерево. */
  TT_FORCE_LOAD_ALL: '__forceLoadAll',
  /** IKey.ROW_CHECKED — после `{name}__` даёт `{name}__row__checked`. */
  ROW_CHECKED: 'row__checked',
  /** IKey.ITEMS — вложенные узлы TreeTable в getData (UniDataTable в строке). */
  ITEMS: 'items',
  /** IKey.ACTION — служебное поле UniData (lazy page reload и др.). */
  ACTION: 'action',
  /** Размер файла (байты). */
  SIZE: 'size',
  /** IKey.COMPLEX_ELEMENT_NAME — имя элемента вложений в UniData (wire key). */
  COMPLEX_ELEMENT_NAME: 'complex__element__name',
  /** IKey.PARAM_CLIENT_TYPE — тип клиента (login, startup-action). */
  PARAM_CLIENT_TYPE: 'clientType',
  /** IKey.CLIENT_WEB — идентификатор веб-клиента на platform. */
  CLIENT_WEB: 'WebClient',
  /** IKeys.PAGE_RELOAD — подгрузка ленивой вкладки (DefaultViewEngine.inlineLazyElements). */
  PAGE_RELOAD: 'reloadPage',
  /** IKey._SELECTED — путь к найденной строке TreeTable (`{tableName}_selected`). */
  SELECTED: '_selected',
  /** IKeys.TT_NEXT_SEARCH_POSITION — «найти далее» (`{tableName}__nextSearchPosition`). */
  TT_NEXT_SEARCH_POSITION: '__nextSearchPosition',
  /** IKeys.SHOW_MESSAGE_DIALOG — показать диалог «не найдено». */
  SHOW_MESSAGE_DIALOG: '__showMessageDialog',
  /** IKeys.TABLE_SELECTED_ROW — видимый индекс строки после поиска. */
  TABLE_SELECTED_ROW: '__selectedRow',
  /** Флаг запуска поиска при reload (`{tableName}__search`). */
  TT_SEARCH: '__search',
  STORAGE_URI: 'storage_uri',
  /** IKeys.LANG — локаль клиента в UniData (changeUser / login). */
  LANG: 'language',
} as const

export default IKey




